module.exports = __webpack_public_path__ + "static/media/1000.568321bf.zip";